module.exports = __webpack_public_path__ + "img/logo_negativo_tagline.d8198133.png";